import ReportReceiptSubmissionTable from "./ReportReceiptSubmissionTable";

export default ReportReceiptSubmissionTable;
